import ApplicationApproveEditsModal from './ApplicationApproveEditsModal'

export default ApplicationApproveEditsModal